Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityNavbarView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_navbar']
  className: 'operator-availability-navbar'

  initialize: ({report}) ->
    @lastUpdatedView = new Customer.Views.Reports.OperatorAvailabilityLastUpdatedView
      report: report
    @refreshView = new Customer.Views.Reports.OperatorAvailabilityRefreshView()
    @refreshSelectView = new Customer.Views.Reports.OperatorAvailabilityAutomaticRefreshSelectView()

    @listenTo(@refreshView, 'refresh', @refresh)
    @listenTo(@refreshSelectView, 'refresh:time:update', @updateAutomaticRefresh)

  render: =>
    @$el.html(@template())
    @$el.find('#operator-availability-last-updated').html(@lastUpdatedView.render().el)
    @$el.find('#operator-availability-refresh').html(@refreshView.render().el)
    @$el.find('#operator-availability-automatic-refresh-select').html(@refreshSelectView.render().el)
    @

  refresh: =>
    @displayPlaceholderContent()
    @refreshSelectView.disable()
    @trigger('refresh')

  updateAutomaticRefresh: (refreshTime) =>
    @trigger('refresh:time:update', refreshTime)

  enableComponents: =>
    @lastUpdatedView.displayContent()
    @refreshView.enable()
    @refreshSelectView.enable()

  displayPlaceholderContent: =>
    @lastUpdatedView.hideContent()

  selectedRefreshTime: =>
    @refreshSelectView.selectedRefreshTime
